import type { FluidLinkViewState } from '../store/schema/FluidLinkViewState';
import getStore from '../store/store';

export function getFluidLink(containerId: string): FluidLinkViewState | undefined {
    const store = getStore();
    return store.linkViewStates.get(containerId);
}
